import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  name: 'formatDateLocal',
})
export class FormatDateLocalPipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }

    try {
      // Parsear la fecha ignorando la zona horaria (tratarla como hora local)
      // Esto es útil cuando el backend guarda hora local con formato UTC
      const dateStr = String(value).replace('Z', '');
      const localDate = moment(dateStr);
      
      // Formato: Nov 5, 2025 3:45 PM
      return localDate.format('MMM D, YYYY h:mm A');
    } catch (error) {
      console.error('Error formatting date:', error);
      return String(value);
    }
  }
}
